var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("searchContainer", {
    attrs: { resetHandler: _vm.reset, searchHandler: _vm.search },
    scopedSlots: _vm._u([
      {
        key: "items",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("input-number", {
                  attrs: {
                    options: { id: "captain_id", step: 1, label: "captain_id" }
                  },
                  model: {
                    value: _vm.filters.captain_id,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "captain_id", $$v)
                    },
                    expression: "filters.captain_id"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("input-date", {
                  attrs: {
                    options: { id: "created_from", label: "created_from" }
                  },
                  model: {
                    value: _vm.filters.created_from,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "created_from", $$v)
                    },
                    expression: "filters.created_from"
                  }
                }),
                _c("input-date", {
                  attrs: { options: { id: "created_to", label: "created_to" } },
                  model: {
                    value: _vm.filters.created_to,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "created_to", $$v)
                    },
                    expression: "filters.created_to"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }